module.exports = "<label translate=\"{{$ctrl.label}}\" ng-if=\"$ctrl.label\"></label><select></select>";